export default __webpack_public_path__ + "static/media/Logo WesternUnion.49a09f7c.svg";